import { I18nContext } from 'contexts/I18n/I18nProvider'
import { RTFSettingsOption } from 'modules/operational/rtf/redux/settings/types'
import React, { useContext } from 'react'
import './index.scss'

type CustomSelectProps = {
  selectValue: string
  setSelectValue: React.Dispatch<React.SetStateAction<string>>
  customValue: string
  setCustomValue: React.Dispatch<React.SetStateAction<string>>
  options: Array<RTFSettingsOption>
}

function handleSelectOnChange(
  e: React.ChangeEvent<HTMLSelectElement>,
  setValue: React.Dispatch<React.SetStateAction<string>>,
  setCustomValue: React.Dispatch<React.SetStateAction<string>>,
) {
  setValue(e.target.value)
  setCustomValue('')
}

export default function CustomSelect({ options, selectValue, setSelectValue, setCustomValue, customValue }: CustomSelectProps) {
  const t = useContext(I18nContext)

  return (
    <>
      <div className="flex-wrap" style={{ display: 'flex', marginBottom: 0 }}>
        <div className="select is-fullwidth">
          <select value={selectValue} onChange={e => handleSelectOnChange(e, setSelectValue, setCustomValue)}>
            {options.map(option => <option key={option.value} value={option.value}>{t(option.label)}</option>)}
          </select>
        </div>
        <div className="input-container-profile-level">
          <h6 className="text is-h6 is-bold">{t('settings.logs_custom_path')}</h6>
          <input
            className="input"
            disabled={selectValue !== 'custom'}
            onChange={e => setCustomValue(e.target.value)}
            value={customValue}
          />
        </div>
      </div>
    </>
  )
}
